import { useContext, useEffect, useReducer, useRef, useState } from "react";
import { HomePage } from "./components/HomePage/HomePage";
import { Navbar } from "./components/NavBar/NavBar";
import { MainContext } from "./MainContext";
import Modal from "./components/Modal/Modal";

function App() {
    const { imageUrls, modal } = useContext(MainContext);

    const [loader, setLoader] = useState(false);
    const loaderRef = useRef<any>({});
    const homePageRef = useRef<any>({});

    useEffect(() => {
        if (imageUrls.length && loader) {
            let loadedCount = 0;

            const onLoad = () => {
                loadedCount++;
                if (loadedCount === imageUrls.length) {
                    if (homePageRef.current.style) {
                        homePageRef.current.style.display = "block";
                    }
                    setTimeout(() => {
                        setLoader(false); // all images are loaded
                        setTimeout(() => {
                            if (loaderRef.current?.style) {
                                loaderRef.current.style.display = "none";
                            }
                        }, 500);
                    }, 2000);
                }
            };

            imageUrls.forEach((url: string) => {
                const img = new Image();
                img.src = url;
                img.onload = onLoad;
                img.onerror = onLoad; // handle failed loads too
            });
        }
    }, [imageUrls, loader]);

    useEffect(() => {
        const imageUrls1 = ["/mini-logo.png"];
        let loadedCount = 0;

        const onLoad = () => {
            console.log("we good");
            loadedCount++;
            if (loadedCount === imageUrls1.length) {
                if (loaderRef.current.style) {
                    loaderRef.current.style.display = "flex";
                }
                setTimeout(() => {
                    setLoader(true);
                }, 500);
            }
        };

        imageUrls1.forEach((url: string) => {
            const img = new Image();
            img.src = url;
            img.onload = onLoad;
            img.onerror = onLoad; // handle failed loads too
        });
    }, []);
    console.log(modal);
    return (
        <>
            {modal && <Modal title={modal.title} subTitle={modal.subTitle} text={modal.text} image={modal.image} type={modal.type}/>}
            <div style={{ opacity: loader ? 1 : 0, display: "none" }} className="loading" ref={loaderRef}>
                <div className="loader">
                    <img src="/mini-logo.png" alt="" />
                </div>
            </div>
            <div ref={homePageRef} style={{ opacity: loader ? 0 : 1, display: "none" }}>
                <HomePage />
            </div>
            {/* <HomePage /> */}

        </>
    );
}

export default App;
